Ext.define('SA.VectorMapExportScalingContainer', {
    alias: 'widget.vector-map-export-scaling-container',
    extend: 'Ext.Component',

    baseCls: 'sa-vector-map-export-scaling-container',

    initComponent() {
        this.callParent();

        this.item = Ext.widget(this.item);
    },

    initEvents() {
        this.callParent();

        this.item.on('resize', this.refreshItemPositionAndScale, this);
    },

    afterRender() {
        this.callParent();

        this.item.render(this.getEl());
    },

    destroy() {
        Ext.destroyMembers(this, 'item');

        this.callParent();
    },

    getScale() {
        return this.getEl().dom.clientWidth / this.item.getEl().dom.offsetWidth;
    },

    onResize() {
        this.callParent(arguments);

        this.refreshItemPositionAndScale();
    },

    refreshItemPositionAndScale() {
        var el = this.getEl().dom,
            itemEl = this.item.getEl().dom;

        itemEl.style.left = `${(el.clientWidth - itemEl.offsetWidth) / 2}px`;
        itemEl.style.top = `${(el.clientHeight - itemEl.offsetHeight) / 2}px`;
        itemEl.style.transform = `scale(${this.getScale()})`;
    }
});